export class AnnualTeamReportViewModel {
  userName: string
  totalDaysPaid: number
  usedPaid: number
  usedUnpaid: number
  usedSick: number
  totalUsed: number
  leftPaid: number
}
